<div *ngIf="DontShow == false" class="text-center">
    <div class="lds-ring text-center mycenter">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
    <br><br><br><br>
    <div class="text-center">
        <br>
        <br>
        <span *ngIf="globalService.resourceArr.length > 0" [class.SmallArabicFont]="globalService.isRTL == true">{{ globalService.resourceArr == null || globalService.resourceArr.length == 0? 'Waited long?' : globalService.Get("WAITED_LONG?") }}</span>
        <br><br>
        <button type="button" class="btn btn-primary" data-toggle="button" (click)="GoHome()" aria-pressed="false"
            autocomplete="off" [class.SmallArabicFont]="globalService.isRTL == true">
            {{ globalService.resourceArr == null || globalService.resourceArr.length == 0? 'Click here' :globalService.Get("CLICK_HERE") }}
        </button>
    </div>
</div>  